//
//
//
//
//
//
var script = {
  name: 'Alert_24'
};

export default script;
